__turbopack_context__.v({
  "controls": "Filters-module__dmaF9q__controls",
  "filterCounter": "Filters-module__dmaF9q__filterCounter",
  "filtersTitle": "Filters-module__dmaF9q__filtersTitle",
  "filtersWrapper": "Filters-module__dmaF9q__filtersWrapper",
  "resetWrapper": "Filters-module__dmaF9q__resetWrapper",
  "separator": "Filters-module__dmaF9q__separator",
});
